import React, { Component, createRef } from 'react';

import { EnvironmentService } from '../../core/services/environmentService';
import { EmbedService, Messages } from '../../core/services/embedService';

import './SingleSignOn.scss';
import { getSsoRoute } from '../../utilities/getSsoRoute';
import { getRedirectTo } from '../../utilities/getRedirectTo';

interface Props {
  action: string
  environmentService: EnvironmentService
  embedService: ReturnType<typeof EmbedService.Instance>
  locationSearch: string
  redirect_url: string
  uscca_access: string
  uscca_lead_fields: string
}

interface State {
  redirect_url: string
}

class SingleSignOn extends Component<Props, State> {
  static defaultProps;

  state: State = {
    redirect_url: this.props.redirect_url
  };
  submitButton = createRef();

  componentDidMount() {
    if (this.props.embedService.isEmbedded) {
      this.props.embedService.messageParent(Messages.Redirect, {
        action: this.props.action,
        redirect_url: this.props.redirect_url
      });
    } else {
      (async () => {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        this.submitButton.current?.click();
      })();
    }
  }

  render() {
    return (
      <>
        <div
          style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff'
          }}
        >
        </div>
        {this.props.action === 'logout' ?
          <form className="sso-form" method="GET" action={getSsoRoute('logout')}>
            <input type="text" name="action" value={this.props.action} />
            <input type="text" name="redirectTo" value={this.props.redirect_url || getRedirectTo('logout')} />
            {/* @ts-expect-error TS(2322) FIXME: Type 'RefObject<unknown>' is not assignable to typ... Remove this comment to see the full error message */}
            <input ref={this.submitButton} type="submit" value="Submit" />
          </form> :
          <form className="sso-form" method="POST" action={getSsoRoute()}>
            <input type="text" name="action" value={this.props.action} />
            <input type="text" name="redirectTo" value={this.props.redirect_url || getRedirectTo()} />
            <input type="text" name="uscca_access" value={this.props.uscca_access} />
            {/* @ts-expect-error TS(2322) FIXME: Type 'RefObject<unknown>' is not assignable to typ... Remove this comment to see the full error message */}
            <input ref={this.submitButton} type="submit" value="Submit" />
          </form>
        }
      </>
    );
  }
}

SingleSignOn.defaultProps = {
  environmentService: EnvironmentService.Instance(),
  embedService: EmbedService.Instance(),
  locationSearch: window.location.search
};

export default SingleSignOn;
